import React from 'react';
import { useAppSelector } from '../../store/hooks';
import { FiSearch } from 'react-icons/fi';

interface AdminSearchBarProps {
  value: string;
  onChange: (v: string) => void;
  placeholder?: string;
  filterOptions?: { label: string; value: string }[];
  filterValue?: string;
  onFilterChange?: (v: string) => void;
}

const AdminSearchBar: React.FC<AdminSearchBarProps> = ({
  value, onChange, placeholder = 'Search...', filterOptions, filterValue, onFilterChange,
}) => {
  const colors = useAppSelector((state) => state.theme.theme);

  return (
    <div className="flex gap-3 flex-wrap">
      <div
        className="flex items-center gap-2 px-3 py-2 rounded-xl flex-1 min-w-[200px]"
        style={{ backgroundColor: colors.inputBackground, border: `1px solid ${colors.borderColor}` }}
      >
        {React.createElement(FiSearch as any, { size: 16, color: colors.grayScale500 })}
        <input
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          className="bg-transparent outline-none flex-1 text-sm"
          style={{ color: colors.textColor }}
        />
      </div>
      {filterOptions && onFilterChange && (
        <select
          value={filterValue}
          onChange={(e) => onFilterChange(e.target.value)}
          className="px-3 py-2 rounded-xl text-sm outline-none"
          style={{
            backgroundColor: colors.inputBackground,
            border: `1px solid ${colors.borderColor}`,
            color: colors.textColor,
          }}
        >
          {filterOptions.map((opt) => (
            <option key={opt.value} value={opt.value}>{opt.label}</option>
          ))}
        </select>
      )}
    </div>
  );
};

export default AdminSearchBar;
